<template>
  <!-- eslint-disable -->
  <div>
    <modelo-add :is-add.sync="isAdd" ref="modelosAdd"> </modelo-add>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mt-2">
          <b-button variant="gradient-danger" @click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
            <span class="align-middle">Atras</span>
          </b-button>
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2 mr-5">
            <label>Vehículo</label>
            <b-form-input :value="vehicleName" readonly />
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2 ml-5">
            <label>Nombre</label>
            <b-form-input v-model="name" placeholder="Nombre" @input="filter"/>
          </b-col>
          <b-col md="2" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end">
          <b-button variant="primary" class="mt-2 mr-1" @click="addModelo">
            <span class="text-nowrap">Agregar</span>
          </b-button>
        </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import modeloAdd from './modeloAdd.vue'
import VehicleService from '@/services/VehicleService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      name: '',
      arrayFilters: [],
      vehicleName: ''
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    modeloAdd
  },
  mounted() {
    this.getVehicleName();
  },
  methods: {
    addModelo(){
      this.isAdd = true
      this.$refs.modelosAdd.getData({})
    },
    back() {
      this.$router.push({ name: 'vehiculos-list' })
    },
    async filter() {
      this.arrayFilters = [];
      if (this.name !== '') {
        this.arrayFilters.push({
          keyContains: 'name',
          key: 'contains',
          value: this.name
        });
      }
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.name = '';
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    async getVehicleName() {
      const vehicleId = parseInt(this.$route.params.id); 
      const vehicleResp = await VehicleService.getVehicleById(vehicleId, this.$store); 
      if (vehicleResp && vehicleResp.data) {
        this.vehicleName = vehicleResp.data.name;
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
